import { Modal } from './Modal'
import { CurrencyType, EventHookInterface } from '../../types'
import { PurchaseDiv } from './processPaymentModalStyles'
import { usePaymentProvider } from '../../hooks/usePaymentProvider'
import { StripeCardPurchaseForm } from '../Forms/StripeCardPurchaseForm'
import { P } from '../Headings'
import { EPaymentProvider } from '../../entities'
import { XenditInvoiceForm } from '../Forms/XenditInvoiceForm'

export const PurchaseTicketModal: React.FC<{
  eventHook: EventHookInterface
  onClose: (success?: boolean) => void
}> = ({ eventHook, onClose }) => {
  const { provider } = usePaymentProvider()
  const { currency } = eventHook.value

  return (
    <Modal close={() => onClose()}>
      <PurchaseDiv
        className={`${currency === CurrencyType.IDR ? 'padding-0' : ''}`}>
        {currency === CurrencyType.IDR ? (
          <XenditInvoiceForm onClose={onClose} eventHook={eventHook} />
        ) : currency === CurrencyType.USD ? (
          <StripeCardPurchaseForm onClose={onClose} eventHook={eventHook} />
        ) : (
          // eslint-disable-next-line i18next/no-literal-string
          <P className="detail paymentError">Unknown payment provider</P>
        )}
      </PurchaseDiv>
    </Modal>
  )
}
